/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../common/auto-form';
import { LIFE_MAX_FIELDS } from './fields';
import { LifeMaxResultView } from './result-view';
import {
  LifeMaxFormValues,
  lifeMaxDefaults,
  lifeMaxSchema,
} from './schema';
import { PRODUCT, buildLifeMaxPayload, simulateLifeMax } from './service';

export function LifeMaxPage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: LifeMaxFormValues) => simulateLifeMax({ values }),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={LIFE_MAX_FIELDS}
            schema={lifeMaxSchema}
            defaults={lifeMaxDefaults}
            isLoading={mutation.isLoading}
            expectedProduct={PRODUCT}
            onSubmit={(values) => {
              const payload = { product: PRODUCT, ...buildLifeMaxPayload(values), debug: true };
              setLastRequest(payload);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <LifeMaxResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
